module.exports = {
  'Your request was successfully registered': 'Tu solicitud se registró exitosamente',
  'Proof of contracting the': 'Comprobante contratación de la',
  'Authorized Credit Limit': 'Línea de Crédito Autorizado',
  'Folio': 'Folio',
  'Date': 'Fecha',
  'Time': 'Hora',
  'Cardholder Management without VAT': 'Administración de Tarjeta del Titular sin IVA',
  'In case you see this offer again at HSBC ATMs or receive the offer via telephone, it is not necessary to accept it again because the card is already on its way.': 'En caso de que vuelvas a ver esta oferta en Cajeros Automáticos HSBC o recibas la oferta vía telefónica no es necesario aceptarla nuevamente pues la tarjeta ya va en camino.',
  'Finish': 'Terminar',
};
